import { render, staticRenderFns } from "./MessageSystemNote.vue?vue&type=template&id=4ac9767b&scoped=true&"
import script from "./MessageSystemNote.vue?vue&type=script&lang=ts&"
export * from "./MessageSystemNote.vue?vue&type=script&lang=ts&"
import style0 from "./MessageSystemNote.vue?vue&type=style&index=0&id=4ac9767b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9767b",
  null
  
)

export default component.exports